import React, { useState, useEffect } from 'react';
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { MdDelete } from 'react-icons/md';
import { Families } from '../utils/data';
import { client } from '../client';
import Spinner from './Spinner';
import { familyQuery } from '../utils/data';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

const CreatePin = ({ user }) => {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(false);
  const [fields, setFields] = useState();
  const [familyId, setFamilyId] = useState();
  const [imageAsset, setImageAsset] = useState();
  const [wrongImageType, setWrongImageType] = useState(false);
  const [imgUrl, setImgUrl] = useState();

  const navigate = useNavigate();
  const [families, setFamilies] = useState();
  const id = '\'' + user?._id + '\'';

  useEffect(() => {
    const query = familyQuery(id);

    client.fetch(query).then((data) => {
      setFamilies(data);
    });

  }, [id])

  const uploadImage = (e) => {
    const selectedFile = e.target.files[0];

    // uploading asset to sanity
    if (selectedFile.type === 'image/png' || selectedFile.type === 'image/svg' || selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/gif' || selectedFile.type === 'image/tiff') {
      setWrongImageType(false);
      setLoading(true);
      client.assets
        .upload('image', selectedFile, { contentType: selectedFile.type, filename: selectedFile.name })
        .then((document) => {
          setImageAsset(document);
          setLoading(false);
        })
        .catch((error) => {
          console.log('Upload failed:', error.message);
        });
    } else if (selectedFile.type) {
      setLoading(true);
      console.log("selectedFile.type");
      console.log(selectedFile.type);

      console.log("onchange called");
      const file = e.target.files[0];
      const storage = getStorage();
      const storageRef = ref(storage, 'video/' + file.name);

      try {
        uploadBytes(storageRef, file).then((snapshot) => {
          console.log('Uploaded a data_url string!');
          const starsRef = ref(storage, 'video/' + file.name);
          getDownloadURL(starsRef)
            .then((url) => {
              // Insert url into an <img> tag to "download"
              console.log(url);
              setImgUrl(url);
              setLoading(false);

            })

        });
      } catch (e) {
        console.log("error");
        console.log(e)
      }

    } else {
      setLoading(false);
      setWrongImageType(true);
    }
  };

  const savePin = () => {
    if (imgUrl && title && familyId) {
      const doc = {
        _type: 'vid',
        title,
        body,
        video: imgUrl,
        userId: user._id,
        postedBy: {
          _type: 'postedBy',
          _ref: user._id,
        },
      };
      client.create(doc).then((res) => {
        client
          .patch(res._id)
          .setIfMissing({ family: [] })
          .insert('after', 'family[-1]', [{
            _key: uuidv4(),
            _ref: familyId,
            _type: 'reference',
          }])
          .commit()
          .then(() => {
            navigate('/');
          });
      });

    } else if (title && imageAsset && familyId) {
      const doc = {
        _type: 'pin',
        title,
        body,
        image: {
          _type: 'image',
          asset: {
            _type: 'reference',
            _ref: imageAsset?._id,
          },
        },
        userId: user._id,
        postedBy: {
          _type: 'postedBy',
          _ref: user._id,
        },
      };
      client.create(doc).then((res) => {
        client
          .patch(res._id)
          .setIfMissing({ family: [] })
          .insert('after', 'family[-1]', [{
            _key: uuidv4(),
            _ref: familyId,
            _type: 'reference',
          }])
          .commit()
          .then(() => {
            navigate('/');
          });
      });
    } else if (title && familyId && !imageAsset) {
      const doc = {
        _type: 'conversation',
        title,
        body,
        userId: user._id,
        postedBy: {
          _type: 'postedBy',
          _ref: user._id,
        },
      };

      client.create(doc).then((res) => {
        client
          .patch(res._id)
          .setIfMissing({ family: [] })
          .insert('after', 'family[-1]', [{
            _key: uuidv4(),
            _ref: familyId,
            _type: 'reference',
          }])
          .commit()
          .then(() => {
            navigate('/');
          });
      });

    } else {
      setFields(true);

      setTimeout(
        () => {
          setFields(false);
        },
        2000,
      );
    }
  };

  return (
    <div className="flex flex-col justify-center items-center mt-5 lg:h-4/5">
      {fields && (
        <p className="text-red-500 mb-5 text-xl transition-all duration-150 ease-in ">Please add all fields.</p>
      )}
      <div className=" flex lg:flex-row flex-col justify-center items-center bg-white lg:p-5 p-3 lg:w-4/5  w-full">
        <div className="bg-secondaryColor p-3 flex flex-0.7 w-full">
          <div className=" flex justify-center items-center flex-col border-2 border-dotted border-gray-300 p-3 w-full h-420">
            {loading && (
              <Spinner />
            )}
            {
              wrongImageType && (
                <p>Wrong file type.</p>
              )
            }
            {!imageAsset && !imgUrl ? (
              // eslint-disable-next-line jsx-a11y/label-has-associated-control
              <label>
                <div className="flex flex-col items-center justify-center h-full">
                  <div className="flex flex-col justify-center items-center">
                    <p className="font-bold text-2xl">
                      <AiOutlineCloudUpload />
                    </p>
                    <p className="text-lg">Click to upload</p>
                  </div>

                  {/* <p className="mt-32 text-gray-400">
                    Recommendation: Use high-quality JPG, JPEG, SVG, PNG, GIF or TIFF less than 20MB
                  </p> */}
                </div>
                <input
                  type="file"
                  name="upload-image"
                  onChange={uploadImage}
                  className="w-0 h-0"
                />
              </label>
            ) : (
              <div className="relative h-full">
                {imgUrl ?
                  <video
                    src={imgUrl}
                    type="video/mp4"
                    controls={true}
                    muted
                    className="h-full w-full"
                  />
                  :
                  <img
                    src={imageAsset?.url}
                    alt="uploaded-pic"
                    className="h-full w-full"
                  />
                }
                <button
                  type="button"
                  className="absolute bottom-3 right-3 p-3 rounded-full bg-white text-xl cursor-pointer outline-none hover:shadow-md transition-all duration-500 ease-in-out"
                  onClick={() => {
                    setImageAsset(null);
                    setImgUrl(null);
                  }
                  }
                >
                  <MdDelete />
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-1 flex-col gap-6 lg:pl-5 mt-5 w-full">
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Add your title"
            className="outline-none text-2xl sm:text-3xl font-bold border-b-2 border-gray-200 p-2"
          />
          {user && (
            <div className="flex gap-2 mt-2 mb-2 items-center bg-white rounded-lg ">
              {/* <img
                src={user.image}
                className="w-10 h-10 rounded-full"
                alt="user-profile"
              />
              <p className="font-bold">{user.userName}</p> */}
            </div>
          )}
          <textarea
            type="text"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Body of post here"
            className="outline-none text-base sm:text-lg border-b-2 border-gray-200 p-2"
          />
          <div className="flex flex-col">
            <div>
              <p className="mb-2 font-semibold text:lg sm:text-xl">Choose family</p>
              <select
                onChange={(e) => {
                  setFamilyId(e.target.value);
                }}
                className="outline-none w-4/5 text-base border-b-2 border-gray-200 p-2 rounded-md cursor-pointer"
              >
                <option value="others" className="sm:text-bg bg-white">Select family</option>
                {families?.map((item) => (
                  <option className="text-base border-0 outline-none capitalize bg-white text-black " value={item?._id}>
                    {item?.familyName}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex justify-end items-end mt-5">
              <button
                type="button"
                onClick={savePin}
                className="bg-indigo-500 text-white font-bold p-2 rounded-full w-28 outline-none"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePin;
